import { render, staticRenderFns } from "./AppPortadaBuscadorSimple.vue?vue&type=template&id=7d0cff90&"
import script from "./AppPortadaBuscadorSimple.vue?vue&type=script&lang=js&"
export * from "./AppPortadaBuscadorSimple.vue?vue&type=script&lang=js&"
import style0 from "./AppPortadaBuscadorSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports